import { ON_CALL_SAVED_THIRD_PARTY } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function onCallSavedThirdParty(payload) {
  return callingAPIMethodWithQueue(ON_CALL_SAVED_THIRD_PARTY, payload);
}